import React from "react";
import { View, TouchableOpacity, StyleSheet } from "react-native";
import Text from "@components/CustomText";
import { Action, getActionIcon } from "../constants";

interface ActionBtnProps {
  onPress: () => void;
  action: string;
  actionAt: string;
  taskActionConfig: any;
}

const ActionBtn: React.FC<ActionBtnProps> = ({
  onPress,
  action,
  actionAt,
  taskActionConfig,
}) => {
  const actionConfig = Object.values(taskActionConfig).find(
    (item) => item.action === action,
  ) as Action;
  const Component = getActionIcon(actionConfig?.icon);
  return Component ? (
    <TouchableOpacity
      onPress={onPress}
      style={[styles.container, { borderColor: actionConfig?.color }]}
    >
      <View
        style={[
          styles.innerContainer,
          { backgroundColor: actionConfig?.color },
        ]}
      >
        <Component />
        <Text style={styles.statusText}>{actionConfig?.subvalue}</Text>
        <Text style={styles.arrow}>›</Text>
      </View>
      <View style={styles.timeContainer}>
        <Text style={styles.lastCallText}>
          Last call: {actionAt.substring(0, 8)}
        </Text>
      </View>
    </TouchableOpacity>
  ) : null;
};

const styles = StyleSheet.create({
  container: {
    borderWidth: 2,
    borderRadius: 12,
    width: 120,
  },
  innerContainer: {
    paddingHorizontal: 8,
    paddingVertical: 2,
    flexDirection: "row",
    alignItems: "center",
  },
  timeContainer: {
    paddingHorizontal: 10,
  },
  statusText: {
    fontSize: 12,
    fontWeight: "bold",
    color: "#000",
    marginLeft: 8,
    flex: 1,
  },
  arrow: {
    marginLeft: "auto",
    fontSize: 18,
    color: "#000",
  },
  lastCallText: {
    fontSize: 10,
    color: "#7A7A7A",
  },
});

export default ActionBtn;
